import React from 'react';
import '../styling/sections.css';

export default function Card({ cardType, title, icon, bodycopy, buttonType, buttoncopy, onClick }) {

    if (cardType === '1') {
        return (  
        <div    
        className="card align-items-center" 
        onClick={onClick} 
        style={{ cursor: 'pointer' }}>
            <div className="card-icon">{icon}</div>
            <h5 className="card-title">{title}</h5>        
        </div>
     );
    } else if (cardType === '2') {
        return (
        <div 
        className="card"
        onClick={onClick} 
        style={{ cursor: 'pointer' }}>
            <div className="card-icon">{icon}</div>
            <h5 className="card-title">{title}</h5>
            <p className="card-description">{bodycopy}</p>
        </div>
     );
    }

    if (cardType === '3' && buttonType === 'primary') {
        return(
            <div className="card">
                <div className="card-icon">{icon}</div>
                <h3 className="card-title">{title}</h3>
                <p className="card-description">{bodycopy}</p>
                <button className="btn-primary btn-view mt-auto" onClick={onClick}>{buttoncopy}</button>
            </div>
        );
    } else if (cardType === '3' && buttonType === 'secondary') {
        return (
        <div className="card">
            <div className="card-icon">{icon}</div>
            <h3 className="card-title">{title}</h3>
            <p className="card-description">{bodycopy}</p>
            <button className="btn-secondary btn-view mt-auto" onClick={onClick}>{buttoncopy}</button>
        </div>

        )
    }

    return null;
}